import PropTypes from "prop-types";
import React, {useState} from "react";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBB} from "../../../consts/funktionaleRollen";
import {createColumn} from "../../../utils/ColumnUtils";
import {formatDate} from "../../../utils/DateUtils";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import CollapsibleTable from "../../tableComponents/CollapsibleTable";
import {MessstellenZuordnenDialog} from "./MessstellenZuordnenDialog";
import Wasserrechte from "./Wasserrechte";

const messstelleColumns = [
    createColumn("abwasseranlage.bezeichnung", "Abwasseranlage"),
    createColumn("bezeichnung", "Bezeichnung"),
    createColumn("messstellenId", "Nummer"),
    createColumn("messstellentyp.value", "Art"),
];

const Bescheidsdaten = ({
                            formFactory,
                            freigabe,
                            messstellen,
                            setMessstellen,
                            modus,
                            bescheidsId,
                            originalBescheidId,
                            statusOptionen,
                            behoerdeOptionen,
                            vorbescheidOptionen,
                            erlaubnisOptionen,
                            isVorbescheidSelectable,
                            bescheidQualitaet,
                            isFreigegeben
                        }) => {
    const [messstellenZuordnenDlgOpen, setMessstellenZuordnenDlgOpen] = useState(false);

    function isDisabled() {
        if (userHasAnyRole([BETREIBER, BEAUFTRAGTER])) return true;
        if (!bescheidsId) return false;
        if (modus === "s") {
            return !userHasAnyRole([ZUST_SBB, FACHADMIN, SYSTEMADMIN]);
        }

        return true;
    }

    function renderButtonbar() {
        if (modus === "s" && !isFreigegeben) {
            if (userHasAnyRole([BETREIBER, BEAUFTRAGTER, ZUST_SBB, FACHADMIN, SYSTEMADMIN])) {
                return (
                    <EAButtonBar style={{gridColumn: "span 3"}}>
                        <EAButton id="messstelleZuordnen" label="Hinzufügen" onClick={() => setMessstellenZuordnenDlgOpen(true)}/>
                    </EAButtonBar>
                );
            }
        }

        return null;
    }

    return (
        <div className="gridl gridForBescheidsdaten tabsheet-content-margin">
            <MessstellenZuordnenDialog
                open={messstellenZuordnenDlgOpen}
                onCancel={() => setMessstellenZuordnenDlgOpen(false)}
                onSubmit={(newMessstellen) => {
                    setMessstellen([...messstellen, ...newMessstellen]);
                    setMessstellenZuordnenDlgOpen(false);
                }}
                selectedIds={messstellen?.map((m) => m.id)}
                bescheidQualitaet={bescheidQualitaet?.id}
            />
            {formFactory.renderAutocompleteWerteliste(
                "bescheidQualitaet",
                "bescheidQualitaet",
                "Bescheidsqualität",
                [],
                false,
                true
            )}
            {formFactory.renderAutocompleteWerteliste(
                "bescheidart",
                "bescheidart",
                "Bescheidsart",
                erlaubnisOptionen,
                false,
                (!((modus === "s" || !bescheidsId) && userHasAnyRole([BETREIBER, BEAUFTRAGTER, ZUST_SBB, FACHADMIN, SYSTEMADMIN])) &&
                    isDisabled()) || isFreigegeben
            )}
            {formFactory.renderAutocomplete(
                "vorbescheid",
                "vorbescheid",
                "Vorbescheid",
                vorbescheidOptionen.data,
                "value",
                "id",
                vorbescheidOptionen.loading,
                false,
                isDisabled() || !isVorbescheidSelectable || isFreigegeben
            )}
            {formFactory.renderSelect(
                "bescheidsstatus",
                "bescheidsstatus",
                "Status",
                statusOptionen,
                !((modus === "s" || !bescheidsId) && userHasAnyRole([BETREIBER, BEAUFTRAGTER, ZUST_SBB, FACHADMIN, SYSTEMADMIN])) &&
                isDisabled()
            )}
            {formFactory.renderInput("aktenzeichen", "aktenzeichen", "Aktenzeichen", "text", isDisabled() || isFreigegeben)}
            {formFactory.renderAutocomplete(
                "behoerde",
                "behoerde",
                "Behörde",
                behoerdeOptionen.data,
                "bezeichnung",
                "id",
                behoerdeOptionen.loading,
                false,
                isDisabled() || isFreigegeben
            )}
            {formFactory.renderDatePicker("bescheidsdatum", "bescheidsdatum", "Bescheiddatum", isDisabled() || isFreigegeben)}
            {formFactory.renderDatePicker("ablaufdatum", "ablaufdatum", "Ablaufdatum", isDisabled() || isFreigegeben)}
            <div style={{gridColumnEnd: "span 4"}}>
                {freigabe?.freigabeAm && (
                    <label>
                        freigeben am {formatDate(freigabe.freigabeAm)} von {freigabe.freigabeVon.value}
                    </label>
                )}
            </div>
            {formFactory.renderInput("bemerkung", "bemerkung", "Bemerkung", "text", isDisabled() || isFreigegeben, {
                multiline: true,
                rows: 5,
                style: {gridColumnEnd: "span 4"},
            })}
            <CollapsibleTable
                id="BescheidsMessstellen"
                label="Messstellen im Bescheid"
                data={messstellen}
                columns={messstelleColumns}
                style={{gridColumn: "span 4"}}
            />
            {renderButtonbar()}
            <Wasserrechte bescheidId={originalBescheidId} style={{gridColumn: "span 4"}}/>
        </div>
    );
};

Bescheidsdaten.propTypes = {
    formFactory: PropTypes.any.isRequired,
};

export default Bescheidsdaten;
